import axios from "axios";
import { toast } from "react-toastify";
import { push } from "connected-react-router";

export const ARTICLES_GET_ARTICLES_REQUEST = "ARTICLES_GET_ARTICLES_REQUEST";
export const ARTICLES_GET_ARTICLES_SUCCESS = "ARTICLES_GET_ARTICLES_SUCCESS";
export const ARTICLES_GET_ARTICLES_FAIL = "ARTICLES_GET_ARTICLES_FAIL";
export const getArticles = (params) => (dispatch) => {
  dispatch({
    type: ARTICLES_GET_ARTICLES_REQUEST,
  });
  axios
    .request({
      url: "dashboard/news_posts",
      params: params,
      method: "GET",
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: ARTICLES_GET_ARTICLES_SUCCESS,
          msg: data.message,
          data: data.data,
        });
      } else {
        dispatch({
          type: ARTICLES_GET_ARTICLES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {},
        });
        // toast.warn(data.message);
      }
    });
};

export const ARTICLES_GET_CATEGORIES_REQUEST =
  "ARTICLES_GET_CATEGORIES_REQUEST";
export const ARTICLES_GET_CATEGORIES_SUCCESS =
  "ARTICLES_GET_CATEGORIES_SUCCESS";
export const ARTICLES_GET_CATEGORIES_FAIL = "ARTICLES_GET_CATEGORIES_FAIL";
export const getCategories = (params) => (dispatch) => {
  dispatch({
    type: ARTICLES_GET_CATEGORIES_REQUEST,
  });
  axios
    .request({
      url: "categories",
      params: {
        post_type: "news_post",
      },
      method: "GET",
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: ARTICLES_GET_CATEGORIES_SUCCESS,
          msg: data.message,
          data: data.data,
        });
      } else {
        dispatch({
          type: ARTICLES_GET_CATEGORIES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {},
        });
        // toast.warn(data.message);
      }
    });
};

export const ARTICLES_GET_AUTHORS_REQUEST = "ARTICLES_GET_AUTHORS_REQUEST";
export const ARTICLES_GET_AUTHORS_SUCCESS = "ARTICLES_GET_AUTHORS_SUCCESS";
export const ARTICLES_GET_AUTHORS_FAIL = "ARTICLES_GET_AUTHORS_FAIL";
export const getAuthors = (params) => (dispatch) => {
  dispatch({
    type: ARTICLES_GET_AUTHORS_REQUEST,
  });
  axios
    .request({
      url: "dashboard/posts/authors",
      params,
      method: "GET",
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: ARTICLES_GET_AUTHORS_SUCCESS,
          msg: data.message,
          data: data.data,
        });
      } else {
        dispatch({
          type: ARTICLES_GET_AUTHORS_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {},
        });
        // toast.warn(data.message);
      }
    });
};

export const ARTICLES_GET_ARTICLE_REQUEST = "ARTICLES_GET_ARTICLE_REQUEST";
export const ARTICLES_GET_ARTICLE_SUCCESS = "ARTICLES_GET_ARTICLE_SUCCESS";
export const ARTICLES_GET_ARTICLE_FAIL = "ARTICLES_GET_ARTICLE_FAIL";
export const getArticle = (id) => (dispatch) => {
  dispatch({
    type: ARTICLES_GET_ARTICLE_REQUEST,
  });
  axios
    .request({
      url: "dashboard/post",
      params: {
        post_id: id,
      },
      method: "GET",
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: ARTICLES_GET_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data,
        });
      } else {
        dispatch({
          type: ARTICLES_GET_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {},
        });
        // toast.warn(data.message);
      }
    });
};

export const ARTICLES_EDIT_ARTICLE_REQUEST = "ARTICLES_EDIT_ARTICLE_REQUEST";
export const ARTICLES_EDIT_ARTICLE_SUCCESS = "ARTICLES_EDIT_ARTICLE_SUCCESS";
export const ARTICLES_EDIT_ARTICLE_FAIL = "ARTICLES_EDIT_ARTICLE_FAIL";
export const editArticle =
  ({
    post_id,
    category_ids,
    title,
    body,
    status,
    cover_img,
    author_name,
    published_at,
    tick_expires_at,
  }) =>
  (dispatch) => {
    let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
    params.append("post_id", post_id);
    params.append("category_ids", category_ids);
    params.append("title", title);
    params.append("body", body);
    params.append("status", status);
    if (cover_img) {
      params.append("cover_image", cover_img);
    }
    params.append("author_name", author_name);
    params.append("published_at", published_at);
    params.append("tick_expires_at", tick_expires_at);
    dispatch({
      type: ARTICLES_EDIT_ARTICLE_REQUEST,
    });
    axios
      .request({
        url: "dashboard/news_post/edit",
        data: params,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(({ data }) => {
        if (data.success) {
          dispatch({
            type: ARTICLES_EDIT_ARTICLE_SUCCESS,
            msg: data.message,
            data: data.data,
          });
          dispatch(push("/dash/admin/articles"));
        } else {
          dispatch({
            type: ARTICLES_EDIT_ARTICLE_FAIL,
            msg: data.message,
            errors: data.errors ? data.errors : {},
          });
          // toast.warn(data.message);
        }
      });
  };

export const ARTICLES_CREATE_ARTICLE_REQUEST =
  "ARTICLES_CREATE_ARTICLE_REQUEST";
export const ARTICLES_CREATE_ARTICLE_SUCCESS =
  "ARTICLES_CREATE_ARTICLE_SUCCESS";
export const ARTICLES_CREATE_ARTICLE_FAIL = "ARTICLES_CREATE_ARTICLE_FAIL";
export const createArticle =
  ({
    category_ids,
    // title,
    // body,
    // status,
    // cover_img,
    // author_name,
    // published_at
  }) =>
  (dispatch) => {
    // let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
    // params.append("category_ids", category_ids);
    // params.append("title", title);
    // params.append("body", body);
    // params.append("status", status);
    // if (cover_img) {
    //   params.append("cover_image", cover_img);
    // }
    // params.append("author_name", author_name);
    // params.append("published_at", published_at);
    dispatch({
      type: ARTICLES_CREATE_ARTICLE_REQUEST,
    });
    axios
      .request({
        url: "dashboard/news_post/create",
        data: {
          category_ids,
        },
        method: "POST",
      })
      .then(({ data }) => {
        if (data.success) {
          dispatch({
            type: ARTICLES_CREATE_ARTICLE_SUCCESS,
            msg: data.message,
            data: data.data,
          });
          // dispatch(push("/admin/articles"));
          dispatch(push("/dash/admin/articles/" + data.data.id + "/edit"));
        } else {
          dispatch({
            type: ARTICLES_CREATE_ARTICLE_FAIL,
            msg: data.message,
            errors: data.errors ? data.errors : {},
          });
          toast.warn(data.message);
        }
      });
  };

export const ARTICLES_REMOVE_ARTICLE_REQUEST =
  "ARTICLES_REMOVE_ARTICLE_REQUEST";
export const ARTICLES_REMOVE_ARTICLE_SUCCESS =
  "ARTICLES_REMOVE_ARTICLE_SUCCESS";
export const ARTICLES_REMOVE_ARTICLE_FAIL = "ARTICLES_REMOVE_ARTICLE_FAIL";
export const removeArticle = (post_id) => (dispatch) => {
  dispatch({
    type: ARTICLES_REMOVE_ARTICLE_REQUEST,
  });
  axios
    .request({
      url: "dashboard/post/remove",
      data: {
        post_id,
      },
      method: "post",
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: ARTICLES_REMOVE_ARTICLE_SUCCESS,
        });
        toast.success(data.message);
        dispatch(push("/dash/admin/articles"));
      } else {
        dispatch({
          type: ARTICLES_REMOVE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {},
        });
        // toast.warn(data.message);
      }
    });
};
